import { Dispatch, useEffect, useReducer, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from 'api/API';
import { DeviceResponse } from 'api/Responses/DeviceResponses';
import { DeviceAction, deviceActions } from 'reducers/DeviceReducer/deviceActions';
import deviceReducer, { initialDevice } from 'reducers/DeviceReducer/deviceReducer';

interface UseDevice {
  device: DeviceResponse;
  dispatchDevice: Dispatch<DeviceAction>;
  loading: boolean;
}

const useDevice = (id: string, isUsingV2: boolean, goBack: boolean): UseDevice => {
  const [loading, setLoading] = useState(true);
  const [device, dispatchDevice] = useReducer(deviceReducer, initialDevice);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    (async (): Promise<void> => {
      try {
        if (isUsingV2) {
          const deviceV2 = await API.device.getV2(id);
          dispatchDevice(deviceActions.init(deviceV2));
        } else {
          const device = await API.device.get(id);
          dispatchDevice(deviceActions.init(device));
        }
      } catch (error) {
        API.errorHandler(error);
        goBack && navigate(-1);
      }
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { loading, device, dispatchDevice };
};

export default useDevice;
